module.exports = __webpack_public_path__ + "media/packs/src/webfonts/fa-solid-900-afbdcbccd6861d9cdc38c86f721653a4.woff";